import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const SLIDES = [{
  src: 'https://cdn.magicpatterns.com/uploads/dwPuCK6PcDicLwT5xrmkin/TOMO-1_(3).png',
  alt: 'Tomo 1 – El Enemigo Silencioso en Casa'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ixQqpgGVNGu67PSvraWB9B/TOMO-1_(2).png',
  alt: 'Contenido del Tomo 1 – La ilusión del tiempo libre'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eKiZ3WTGL4apWnLmtq7u7g/ChatGPT_Image_5_feb_2026,_05_30_49_p.m..png',
  alt: 'Tomo 2 – El Daño Invisible'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8Cmm8TgZLRe6Mi1ip4R4bx/TOMO-2_(1).png',
  alt: 'Contenido del Tomo 2 – ¿Por qué se enojan?'
}];
interface ProductCarouselProps {
  onScrollToPrice: () => void;
}
export function ProductCarousel({
  onScrollToPrice
}: ProductCarouselProps) {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent(c => c === 0 ? SLIDES.length - 1 : c - 1);
  const next = () => setCurrent(c => c === SLIDES.length - 1 ? 0 : c + 1);
  return <div className="w-full max-w-lg mx-auto" data-id="element-198">
      {/* Image container */}
      <div className="relative overflow-hidden rounded-xl bg-white shadow-sm border border-gray-100" data-id="element-199">
        <div className="cursor-pointer" onClick={onScrollToPrice} data-id="element-200">
          <div data-id="element-201">
            <img src={SLIDES[current].src} alt={SLIDES[current].alt} className="w-full h-auto object-contain" style={{
            transition: 'opacity 0.3s ease'
          }} data-id="element-202" />
          </div>
        </div>

        {/* Navigation arrows */}
        <button onClick={e => {
        e.stopPropagation();
        prev();
      }} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 hover:bg-white rounded-full shadow-md flex items-center justify-center transition-colors" aria-label="Anterior" data-id="element-203">
          <ChevronLeft className="w-5 h-5 text-gray-700" data-id="element-204" />
        </button>
        <button onClick={e => {
        e.stopPropagation();
        next();
      }} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 hover:bg-white rounded-full shadow-md flex items-center justify-center transition-colors" aria-label="Siguiente" data-id="element-205">
          <ChevronRight className="w-5 h-5 text-gray-700" data-id="element-206" />
        </button>
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center gap-2 mt-4" data-id="element-207">
        {SLIDES.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-all ${i === current ? 'bg-red-600 w-6' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-208" />)}
      </div>

      {/* Caption */}
      <p className="text-center text-sm text-gray-500 mt-3" data-id="element-209">
        {current + 1} de {SLIDES.length} — Mirá lo que vas a encontrar adentro
      </p>
    </div>;
}